// This file is auto-generated. Do not edit!

export default [
  {
    symbol: "WETH",
    token: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
    fToken: "0x45Df0656F8aDf017590009d2f1898eeca4F0a205",
  },
  {
    symbol: "USDC",
    token: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
    fToken: "0x1A996cb54bb95462040408C06122D45D6Cdb6096",
  },
  {
    symbol: "USD₮0",
    token: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
    fToken: "0x4A03F37e7d3fC243e3f99341d36f4b829BEe5E03",
  },
  {
    symbol: "wstETH",
    token: "0x5979D7b546E38E414F7E9822514be443A4800529",
    fToken: "0x66C25Cd75EBdAA7E04816F643d8E46cecd3183c9",
  },
  {
    symbol: "weETH",
    token: "0x35751007a407ca6FEFfE80b3cB397736D2cf4dbe",
    fToken: "0x0D00C4A2f766b7AFE2cc8F6467E296400A32B239",
  },
  {
    symbol: "ARB",
    token: "0x912CE59144191C1204E64559FE8253a0e49E6548",
    fToken: "0xbE3860FD4c3facDf8ad57Aa8c1A36D6dc4390a49",
  },
  {
    symbol: "sUSDS",
    token: "0xdDb46999F8891663a8F2828d25298f70416d7610",
    fToken: "0x3459fcc94390C3372c0F7B4cD3F8795F0E5aFE96",
  },
  {
    symbol: "GHO",
    token: "0x7dfF72693f6A4149b17e7C6314655f6A9F7c8B33",
    fToken: "0x037dFf1C12805707d7c29F163E0F09fC9102657A",
  },
  {
    symbol: "PYUSD",
    token: "0x46850aD61C2B7d64d08c9C754F45254596696984",
    fToken: "0x24BB6C093e15658AcE2C34bEe9ac16F0A6ED2b01",
  },
] as const
